// removed by extract-text-webpack-plugin
module.exports = {"legend_wrapper":"legend_wrapper__kuKK_","legendCenter":"legendCenter__113xP","legendText":"legendText__FLtW6","legendColor":"legendColor__1KNAA","legendLabel":"legendLabel__xZ3on"};


//////////////////
// WEBPACK FOOTER
// ./components/donut-chart-legend/style.scss
// module id = gi+I
// module chunks = 22